import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "../components/AppLayout";
import { RootPage } from "../pages/RootPage";
import { PrivacyPolicyPage } from "../pages/PrivacyPolicyPage";
import { AnalyticsPage } from "../pages/AnalyticsPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootPage to="/app/analytics" />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "/app",
        element: <RootPage to="/app/analytics" />,
      },
      {
        path: "app/analytics",
        element: <AnalyticsPage />,
      },
      {
        path: "app/settings",
        element: <RootPage to="/app/analytics" />,
      },
      {
        path: "*",
        element: <RootPage to="/app/analytics" />,
      },
    ],
  },
]);
